export const emptyProfileObject= {
    firstName: "", // String!
    lastName: "", // String!
    dateOfBirth: "", // String!
    timeOfBirth: null, // String!
    gender: "", // String!
    city: "", // String!
    state: "", // String!
    pin: "", // String!
    country: "", // String!
    qualification: [], // [String!]!
    occupation: "", // String!
    employedIn: "", // String!
    annualIncome: "", // String!
    isNRI: false, // Boolean!
    maritalStatus: "", // String!
    motherTongue: "", // String!
    religion: "", // String!
    caste: "", // String!
    gotra: "", // String!
    nakshatra: "", // String!
    kuldevta: "", // String!
    rashi: "", // String!
    languagesKnown: [], // [String!]!
    bloodGroup: "", // String!
    height: "", // Int! -> persisted as string in initialization
    heightFeet: 3,
    heightInch: 0,
    weight: "", // Int!-> persisted  as string
    foodHabits: "", // String!
    drinkHabits: "", // String!
    smokeHabits: "", // String!
    complexion: "",
    fatherName: "", // String!
    fatherNumber: "", // String!
    fatherNumberCountry: 91, // String!
    motherName: "", // String!
    motherNumber: "", // String!
    motherNumberCountry: 91, // String!
    contactNumber: "", // String!
    contactNumberCountry: 91, // String!
    contactEmail: "", // String!
    bio: "", // String!
};